module.exports = __webpack_public_path__ + "img/img06.b058bd47.png";